export const ListingsRoutes = [
  {
    path: '/listings/:id',
    name: 'ListingsDetail',
    component: () => import('@pages/listings-detail/index.vue'),
    meta: {
      title: '车源详情',
      layout: 'plain',
    },
  },
]
